var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rest-privat" }, [
    _vm.is_load
      ? _c("div", { staticClass: "p-3" }, [
          _c("i", { staticClass: "fal fa-spinner fa-spin" }),
          _vm._v("\n        Завантаження...\n    "),
        ])
      : _c("div", [
          _c("ul", { staticClass: "nav nav-tabs mb-3" }, [
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.active_tab === "settings" },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.active_tab = "settings"
                    },
                  },
                },
                [_vm._v("\n                    Налаштування\n                ")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.active_tab === "receivers" },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.active_tab = "receivers"
                    },
                  },
                },
                [_vm._v("\n                    Отримувачі\n                ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.active_tab === "settings"
            ? _c("div", { staticClass: "card" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v("Privat key"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.main.privat_key,
                          expression: "form.main.privat_key",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Privat key" },
                      domProps: { value: _vm.form.main.privat_key },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.form.main,
                            "privat_key",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.active_tab === "receivers"
            ? _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-header d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("strong", [_vm._v("Отримувачі")]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.addReceiver },
                      },
                      [
                        _c("i", { staticClass: "fal fa-plus" }),
                        _vm._v(
                          "\n                    Додати\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _vm.form.receivers.length <= 0
                      ? _c("div", { staticClass: "alert alert-info mb-0" }, [
                          _vm._v(
                            "\n                    Отримувачі ще не додані\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.form.receivers, function (receiver, index) {
                      return _c(
                        "div",
                        {
                          key: receiver._key,
                          staticClass: "receiver-card border rounded p-3 mb-3",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center mb-3",
                            },
                            [
                              _c("strong", [
                                _vm._v("Отримувач #" + _vm._s(index + 1)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeReceiver(index)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fal fa-trash" })]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { staticClass: "form-label" }, [
                                  _vm._v("ОКПО"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: receiver.okpo,
                                      expression: "receiver.okpo",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", placeholder: "ОКПО" },
                                  domProps: { value: receiver.okpo },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        receiver,
                                        "okpo",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-5" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { staticClass: "form-label" }, [
                                  _vm._v("Назва"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: receiver.name,
                                      expression: "receiver.name",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Назва отримувача",
                                  },
                                  domProps: { value: receiver.name },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        receiver,
                                        "name",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-2" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { staticClass: "form-label" }, [
                                  _vm._v("Активний"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-switch mt-2",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: receiver.state,
                                          expression: "receiver.state",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "privat_receiver_state_" + index,
                                      },
                                      domProps: {
                                        checked: Array.isArray(receiver.state)
                                          ? _vm._i(receiver.state, null) > -1
                                          : receiver.state,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = receiver.state,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  receiver,
                                                  "state",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  receiver,
                                                  "state",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(receiver, "state", $$c)
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "privat_receiver_state_" + index,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              receiver.state ? "Так" : "Ні"
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _c("receiver-categories", {
                                attrs: {
                                  receiver: receiver,
                                  restaurant: _vm.rest,
                                  used_ids: _vm.getUsedCategoryIds(index),
                                },
                                on: { duplicate: _vm.showDuplicateCategory },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("strong", [_vm._v("Налаштування Privat")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }